import { svg } from 'lit';

export const loadingIcon = svg`<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
  <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="bevel" stroke="#2273D6" stroke-width="3">
    <circle cx="10" cy="10" r="8" stroke-opacity=".3"/>
    <path stroke-dasharray="20 2000" d="M10 18a8 8 0 100-16 8 8 0 000 16z"/>
  </g>
</svg>`;
